import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TagsComponent} from './tag/tags.component';
import {ComponentsModule} from '../../components/components.module';
import {RouterModule} from '@angular/router';
import {ButtonModule} from 'primeng/button';
import {TableModule} from 'primeng/table';
import {MenuModule} from 'primeng/menu';
import {SplitButtonModule} from 'primeng/splitbutton';
import {DividerModule} from 'primeng/divider';
import {InputTextModule} from 'primeng/inputtext';
import {DynamicDialogModule} from 'primeng/dynamicdialog';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {PanelModule} from 'primeng/panel';
import {DatePickerModule} from 'primeng/datepicker';
import {MultiSelectModule} from 'primeng/multiselect';
import {CheckboxModule} from 'primeng/checkbox';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {DialogModule} from 'primeng/dialog';
import {ProgressBarModule} from 'primeng/progressbar';
import {DropdownModule} from 'primeng/dropdown';
import {ConfirmPopupModule} from 'primeng/confirmpopup';
import {TreeModule} from 'primeng/tree';
import {OrderListModule} from 'primeng/orderlist';
import {ChipsModule} from 'primeng/chips';
import {PickListModule} from 'primeng/picklist';
import {ChipModule} from 'primeng/chip';
import {TabViewModule} from 'primeng/tabview';
import {MonacoEditorModule} from 'ngx-monaco-editor-v2';
import {TextareaModule} from 'primeng/textarea';
import {TagsEventComponent} from './tags-event/tags-event.component';
import {SelectButtonModule} from 'primeng/selectbutton';
import {MessageModule} from 'primeng/message';
import {TagsEventDetailComponent} from './tags-event-detail/tags-event-detail.component';
import {TagModule} from "primeng/tag";
import {InputSwitchModule} from "primeng/inputswitch";
import {RippleModule} from "primeng/ripple";
import {TooltipModule} from "primeng/tooltip";
import {ToastModule} from "primeng/toast";
import {BeautifulFilterComponent} from "../../components/filter/beautiful-filter/beautiful-filter.component";
import { PipesModule } from '../../pipes/pipes.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    declarations: [
        TagsComponent,
        TagsEventComponent,
        TagsEventDetailComponent
    ],
    imports: [
        CommonModule,
        ComponentsModule,
        TooltipModule,
        RouterModule,
        ButtonModule,
        TableModule,
        MenuModule,
        SplitButtonModule,
        DividerModule,
        InputTextModule,
        DynamicDialogModule,
        FormsModule,
        PanelModule,
        DatePickerModule,
        MultiSelectModule,
        CheckboxModule,
        ConfirmDialogModule,
        DialogModule,
        ProgressBarModule,
        ReactiveFormsModule,
        DropdownModule,
        ConfirmPopupModule,
        TreeModule,
        OrderListModule,
        ChipsModule,
        PickListModule,
        ChipModule,
        TabViewModule,
        MonacoEditorModule,
        TextareaModule,
        TagModule,
        InputSwitchModule,
        RippleModule,
        ToastModule,
        BeautifulFilterComponent,
        PipesModule,
        TranslateModule,
        SelectButtonModule,
        MessageModule
    ],
    exports: [TagsComponent, TagsEventComponent, TagsEventDetailComponent]
})
export class TagsModule {
}
